import { useState } from 'react'

export function useCodeBlockCopy(code) {
  const [copied, setCopied] = useState(false)
  const handleCopy = () => {
    navigator.clipboard.writeText(code)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }
  return { copied, handleCopy }
}
